var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseButton,{attrs:{"variant":"warning","size":"sm","disabled":_vm.scannedItems.length === 0 || _vm.loadingStock === 'bulk-update-scanned',"loading":_vm.loadingStock === 'bulk-update-scanned',"icon":_vm.actionIcon},nativeOn:{"click":function($event){return _vm.updateStockStatus()}}},[_vm._v("Process Items")])
}
var staticRenderFns = []

export { render, staticRenderFns }